const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

// 夏令时配置
const dstConfig = r =>
  require.ensure(
    [],
    () => r(require('@/modules/dstConfig/dstConfig.vue')),
    'dstConfig'
  )

const dstConfigRouter = {
  path: '/settings',
  name: 'dstConfig',
  component: Layout,
  meta: {
    id: '7e32924eaf444f228e6efc1ef4fcebd1',
    auth: true,
    breadcrumbShow: false
  },
  children: [
    {
      path: '/settings/dstConfig',
      name: 'dstConfig',
      component: dstConfig,
      meta: {
        id: '7e32924eaf444f228e6efc1ef4fcebd1',
        // breadcrumbShow: false,
        auth: true
      }
    }
  ]
}
export default dstConfigRouter



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/dstConfig.js